/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { createReportUrl } from '../fn/admin-reporting-report-url/create-report-url';
import { CreateReportUrl$Params } from '../fn/admin-reporting-report-url/create-report-url';
import { deleteReportUrl } from '../fn/admin-reporting-report-url/delete-report-url';
import { DeleteReportUrl$Params } from '../fn/admin-reporting-report-url/delete-report-url';
import { listReportUrlGrants } from '../fn/admin-reporting-report-url/list-report-url-grants';
import { ListReportUrlGrants$Params } from '../fn/admin-reporting-report-url/list-report-url-grants';
import { listReportUrls } from '../fn/admin-reporting-report-url/list-report-urls';
import { ListReportUrls$Params } from '../fn/admin-reporting-report-url/list-report-urls';
import { ReportUrl } from '../models/report-url';
import { SettingOptionDto } from '../models/setting-option-dto';
import { updateReportUrl } from '../fn/admin-reporting-report-url/update-report-url';
import { UpdateReportUrl$Params } from '../fn/admin-reporting-report-url/update-report-url';

@Injectable({ providedIn: 'root' })
export class AdminReportingReportUrlService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `adminReportUrlControllerListReportUrls()` */
  static readonly AdminReportUrlControllerListReportUrlsPath = '/admin/reporting/report-url';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listReportUrls()` instead.
   *
   * This method doesn't expect any request body.
   */
  listReportUrls$Response(
    params?: ListReportUrls$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<ReportUrl>>> {
    return listReportUrls(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listReportUrls$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listReportUrls(params?: ListReportUrls$Params, context?: HttpContext): Observable<Array<ReportUrl>> {
    return this.listReportUrls$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ReportUrl>>): Array<ReportUrl> => r.body)
    );
  }

  /** Path part for operation `adminReportUrlControllerCreateReportUrl()` */
  static readonly AdminReportUrlControllerCreateReportUrlPath = '/admin/reporting/report-url';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createReportUrl()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createReportUrl$Response(
    params: CreateReportUrl$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<ReportUrl>> {
    return createReportUrl(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createReportUrl$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createReportUrl(params: CreateReportUrl$Params, context?: HttpContext): Observable<ReportUrl> {
    return this.createReportUrl$Response(params, context).pipe(
      map((r: StrictHttpResponse<ReportUrl>): ReportUrl => r.body)
    );
  }

  /** Path part for operation `adminReportUrlControllerUpdateReportUrl()` */
  static readonly AdminReportUrlControllerUpdateReportUrlPath = '/admin/reporting/report-url/{reportUrlId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateReportUrl()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateReportUrl$Response(
    params: UpdateReportUrl$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<ReportUrl>> {
    return updateReportUrl(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateReportUrl$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateReportUrl(params: UpdateReportUrl$Params, context?: HttpContext): Observable<ReportUrl> {
    return this.updateReportUrl$Response(params, context).pipe(
      map((r: StrictHttpResponse<ReportUrl>): ReportUrl => r.body)
    );
  }

  /** Path part for operation `adminReportUrlControllerDeleteReportUrl()` */
  static readonly AdminReportUrlControllerDeleteReportUrlPath = '/admin/reporting/report-url/{reportUrlId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteReportUrl()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteReportUrl$Response(
    params: DeleteReportUrl$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    return deleteReportUrl(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteReportUrl$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteReportUrl(params: DeleteReportUrl$Params, context?: HttpContext): Observable<void> {
    return this.deleteReportUrl$Response(params, context).pipe(map((r: StrictHttpResponse<void>): void => r.body));
  }

  /** Path part for operation `adminReportUrlControllerListReportUrlGrants()` */
  static readonly AdminReportUrlControllerListReportUrlGrantsPath = '/admin/reporting/report-url/grants';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listReportUrlGrants()` instead.
   *
   * This method doesn't expect any request body.
   */
  listReportUrlGrants$Response(
    params?: ListReportUrlGrants$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<SettingOptionDto>>> {
    return listReportUrlGrants(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listReportUrlGrants$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listReportUrlGrants(params?: ListReportUrlGrants$Params, context?: HttpContext): Observable<Array<SettingOptionDto>> {
    return this.listReportUrlGrants$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<SettingOptionDto>>): Array<SettingOptionDto> => r.body)
    );
  }
}
